
import React, { useContext, createContext, useState } from 'react';

export const DelegatedFrameContext = createContext({
  delegatedFrame: null,
  setDelegatedFrame: () => {},
});

export const DelegatedFrameContextProvider = (props) => {
  const [delegatedFrame, setDelegatedFrame] = useState(null);

  const context = {
    delegatedFrame,
    setDelegatedFrame,
  };

  return <DelegatedFrameContext.Provider value={context}>{props.children}</DelegatedFrameContext.Provider>;
};

export const useDelegatedFrameContext = () => useContext(DelegatedFrameContext);
